import { useEffect, FC } from 'react';

interface ExternalRedirectProps {
    to: string;
}

const ExternalRedirect: FC<ExternalRedirectProps> = ({ to }) => {
    useEffect(() => {
        window.location.href = to;
    }, [to]);

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            Redirection vers Genesis...
        </div>
    );
};

export default ExternalRedirect;
